import type { ReactNode } from 'react'
import styles from './PageContainer.module.css'

interface PageContainerProps {
  title: string
  /** Optional supporting line under the title. */
  lede?: ReactNode
  /** Optional single dominant action rendered in the header. */
  action?: ReactNode
  children: ReactNode
}

/**
 * Standard screen frame: an editorial page header (title + optional lede and a
 * single action) followed by the screen body. Keeps heading structure and
 * spacing consistent across the four product areas.
 */
export function PageContainer({ title, lede, action, children }: PageContainerProps) {
  return (
    <>
      <header className={styles.header}>
        <div className={styles.heading}>
          <h1 className={styles.title}>{title}</h1>
          {lede ? <p className={styles.lede}>{lede}</p> : null}
        </div>
        {action ? <div className={styles.action}>{action}</div> : null}
      </header>
      {children}
    </>
  )
}
